<template>
  <div class="my-content">
    <div class="left-content">
      <Form
        label-position="right"
        :model="dataDetails"
        :label-width="140"
        :rules="ruleFrom"
        ref="dataDetails"
      >
        <FormItem :label="$t('airport')" prop="target_airport">
          <Select
            v-model="dataDetails.target_airport"
            filterable
            placeholder="Please Select Airport"
          >
            <Option v-for="item in airportList" :value="item" :key="item">{{
              item
            }}</Option>
          </Select>
        </FormItem>
        <FormItem :label="$t('warehouseName')" prop="warehouse_id">
          <Select
            v-model="dataDetails.warehouse_id"
            filterable
            placeholder="Please Select Warehouse"
            @on-change="changeClick"
          >
            <Option
              v-for="item in warehouseList"
              :value="item.id"
              :key="item.id"
              >{{ item.code }}</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('channel_name')" prop="channel">
          <Select
            v-model="dataDetails.channel"
            filterable
            placeholder="Please Select channel"
            @on-change="changeClick"
          >
            <Option
              v-for="item in channelList"
              :value="item.channel_code"
              :key="item.channel_code"
              >{{ item.channel_name }}({{ item.channel_code }})</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('packing_number')" prop="packing_number">
          <i-Input
            v-model="dataDetails.packing_number"
            placeholder="Please Enter packingNumber"
          ></i-Input>
        </FormItem>
        <FormItem :label="$t('bagCode')" prop="package_id">
          <div class="bag-code">
            <template v-if="packList.length > 0">
              <div class="check-all">
                <Checkbox :value="checkAll" @on-change="handleCheckAll">
                  {{ $t("all") }}
                </Checkbox>
              </div>
              <div class="check-client">
                <CheckboxGroup
                  v-model="dataDetails.package_id"
                  @on-change="checkAllGroupChange"
                >
                  <Row :gutter="10">
                    <Col
                      span="8"
                      v-for="item in packList"
                      :key="item"
                      style="margin-bottom: 10px"
                    >
                      <Checkbox :label="item" border></Checkbox>
                    </Col>
                  </Row>
                </CheckboxGroup>
              </div>
            </template>
          </div>
        </FormItem>
        <div class="btn-div">
          <!-- <Button
            type="dashed"
            class="submit-btn"
            size="large"
            @click="SearchSubmit"
            icon="md-search"
            :disabled="dataDetails.package_id.length > 0 ? false : true"
          >
            {{ $t("search") }}
          </Button> -->
          <Button
            type="primary"
            class="submit-btn"
            size="large"
            @click="submitClick"
            icon="md-add"
          >
            {{ $t("order_submit") }}
          </Button>
        </div>
      </Form>
    </div>
    <div class="right-content">
      <div class="search-div">
        <i-Input v-model="keywords" placeholder="Please Enter keywords">
        </i-Input>
        <Button
          type="dashed"
          @click="SearchSubmit(keywords)"
          icon="md-search"
          :disabled="dataDetails.package_id.length > 0 ? false : true"
        >
          {{ $t("search") }}
        </Button>
      </div>
      <Table
        border
        :columns="tableTitle"
        :data="tableData"
        stripe
        :loading="loading"
        height="700"
      ></Table>
    </div>
  </div>
</template>

<script>
import { getPickChannel, add, getPickShipents } from "@/api/packing/packing";
import { getWarehouse } from "@/api/storage/warehouse";

export default {
  name: "newPacking",
  data() {
    return {
      dataDetails: {
        target_airport: "",
        warehouse_id: "",
        packing_number: "",
        channel: "",
        package_id: []
      },
      airportList: ["HK", "GZ"],
      ruleFrom: {
        target_airport: [
          {
            required: true,
            message: "Please select the Airport",
            trigger: "change"
          }
        ],
        warehouse_id: [
          {
            required: true,
            type: "number",
            message: "Please select the Warehouse",
            trigger: "change"
          }
        ],
        channel: [
          {
            required: true,
            type: "number",
            message: "Please select the channel",
            trigger: "change"
          }
        ],
        packing_number: [
          {
            required: true,
            message: "packing_number cannot be empty",
            trigger: "blur"
          }
        ],
        package_id: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "package cannot be empty",
            trigger: "change"
          }
        ]
      },
      indeterminate: true,
      checkAll: false,
      checkAllGroup: [],
      warehouseList: [],
      channelList: [],
      packList: [],
      loading: false,
      objShipments: {},
      tableData: [],
      keywords: "",
      searchData: [],
      bagNum: 0,
      awoNum: 0
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("order_number") + " (" + this.awoNum + ")",
        key: "cnbNum",
        align: "center"
      });
      columns.push({
        title: this.$t("bagCode") + " (" + this.bagNum + ")",
        key: "title",
        align: "center"
      });
      return columns;
    }
  },
  mounted() {
    this.getotherList();
    this.getPickChannelList();
  },
  methods: {
    getotherList() {
      getWarehouse().then(res => {
        this.warehouseList = res.data.payload.rows;
      });
    },
    submitClick() {
      this.$refs["dataDetails"].validate(valid => {
        if (valid) {
          add(this.dataDetails).then(res => {
            if (res.data.code == 0) {
              this.$refs["dataDetails"].resetFields();
              this.packList = [];
              this.tableData = [];
              this.awoNum = this.bagNum = 0;
              this.$Message["success"]({
                background: true,
                content: res.data.msg
              });
            } else {
              this.$Message["error"]({
                background: true,
                content: res.data.msg
              });
            }
          });
        }
      });
    },
    SearchSubmit(val) {
      let arr = [];
      if (val) {
        this.searchData.map(item => {
          if (val == item.title || val == item.cnbNum) {
            arr.push(item);
          }
        });
        this.tableData = arr;
      } else {
        this.tableData = this.searchData;
      }
    },
    changeClick() {
      this.checkAll = false;
      this.objShipments = {};
      this.tableData = [];
      this.dataDetails.package_id = [];
      this.awoNum = this.bagNum = 0;
      if (this.dataDetails.warehouse_id && this.dataDetails.channel) {
        let data = {
          warehouse_id: this.dataDetails.warehouse_id,
          channel: this.dataDetails.channel
        };
        getPickShipents(data).then(res => {
          this.packList = res.data.payload.package;
          this.objShipments = res.data.payload.shipments;
        });
      }
    },
    getPickChannelList() {
      getPickChannel().then(res => {
        this.channelList = res.data.payload;
      });
    },
    handleCheckAll() {
      this.keywords = "";
      this.checkAll = !this.checkAll;
      if (this.checkAll) {
        this.loading = true;

        this.dataDetails.package_id = this.packList;
        let arr = [];
        Object.keys(this.objShipments).forEach(key => {
          this.objShipments[key].map(item => {
            arr.push({ title: key, cnbNum: item });
          });
        });
        this.tableData = this.searchData = arr;
        this.bagNum = this.packList.length;
        this.awoNum = arr.length;
        this.loading = false;
      } else {
        this.dataDetails.package_id = this.tableData = [];
        this.awoNum = this.bagNum = "";
      }
    },
    checkAllGroupChange(data) {
      let arr = [];
      this.keywords = "";
      data.forEach(item => {
        this.objShipments[item].map(val => {
          arr.push({ title: item, cnbNum: val });
        });
      });
      this.tableData = this.searchData = arr;
      if (data.length === this.packList.length) this.checkAll = true;
      else this.checkAll = false;
      this.awoNum = arr.length;
      this.bagNum = data.length;
    }
  }
};
</script>

<style scoped lang="less">
.my-content {
  height: 100%;
  display: flex;
}
.left-content {
  width: ~"calc(100% - 500px)";
  height: 100%;
  background: #fff;
  padding: 10px;
}
.right-content {
  width: 470px;
  height: 100%;
  margin-left: 30px;
  background: #fff;
  padding: 10px;
}
.submit-btn {
  width: 150px;
  margin: 0 20px;
}
.btn-div {
  width: 100%;
  display: flex;
  justify-content: center;
}
.search-div {
  display: flex;
  margin-bottom: 24px;
}
.search-div button {
  margin-left: 20px;
}
.bag-code {
  border: 1px solid #dcdee2;
  height: 450px;
  border-radius: 4px;
}
.check-all {
  position: absolute;
  width: 100%;
  top: 0;
  border-bottom: 1px solid #e9e9e9;
  padding: 0 15px;
}
.check-client {
  position: absolute;
  top: 40px;
  width: 100%;
  height: 400px;
  overflow: auto;
  padding: 0 10px;
}
</style>
